<template>
  <!-- household -->
  <div class="pop-table">
    <dl class="popup-population-wrapper">
      <dt class="popup-population-range">{{ `${circleRange}m圏内人口` }}</dt>
      <dd class="popup-population-total">{{ existInfo ? (calcInfo.total | 0) : '...' }}</dd>
    </dl>
    <table>
      <tbody>
      <tr class="column">
        <td class="year"></td><td>男</td><td>女</td><td>計</td><td>％</td>
      </tr>
      <tr class="less10">
        <td class="column">10代未満</td>
        <td class="column">{{ existInfo ? info.mless10 : '...' }}</td>
        <td class="column">{{ existInfo ? info.fless10 : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sumless10 : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.perless10 : '...' }}</td>
      </tr>
      <tr class="p10s">
        <td class="column">10代</td>
        <td class="column">{{ existInfo ? info.m10s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f10s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum10s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per10s : '...' }}</td>
      </tr>
      <tr class="p20s">
        <td class="column">20代</td>
        <td class="column">{{ existInfo ? info.m20s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f20s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum20s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per20s : '...' }}</td>
      </tr>
      <tr class="p30s">
        <td class="column">30代</td>
        <td class="column">{{ existInfo ? info.m30s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f30s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum30s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per30s : '...' }}</td>
      </tr>
      <tr class="p40s">
        <td class="column">40代</td>
        <td class="column">{{ existInfo ? info.m40s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f40s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum40s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per40s : '...' }}</td>
      </tr>
      <tr class="p50s">
        <td class="column">50代</td>
        <td class="column">{{ existInfo ? info.m50s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f50s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum50s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per50s : '...' }}</td>
      </tr>
      <tr class="p60s">
        <td class="column">60代</td>
        <td class="column">{{ existInfo ? info.m60s : '...' }}</td>
        <td class="column">{{ existInfo ? info.f60s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sum60s : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.per60s : '...' }}</td>
      </tr>
      <tr class="over70">
        <td class="column">70代以上</td>
        <td class="column">{{ existInfo ? info.mover70 : '...' }}</td>
        <td class="column">{{ existInfo ? info.fover70 : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.sumover70 : '...' }}</td>
        <td class="column">{{ existInfo ? calcInfo.perover70 : '...' }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'popTable',
    props: {
      info: {
        type: Object,
        default: null
      }
    },
    computed: {
      existInfo() {
        let existense = Object.keys(this.info).length > 0 ? true : false
        let nullProp = this.info !== null ? true: false
        return existense && nullProp

      },
      circleRange () {
        return this.$store.state.circleRange
      },
      calcInfo () {
        // 各年代ごとに合計を計算
        if(this.info !== null){
          let pop_array = {}
          let total = 0
          let tmp = 0
          for (let cnt = 10; cnt < 70; cnt=cnt+10) {
            tmp = parseInt(this.info["m"+cnt.toString()+"s"]) + parseInt(this.info["f"+cnt.toString()+"s"]);
            pop_array["sum"+cnt.toString()+"s"] = tmp;
            // totalに加算
            total = total + tmp;
          }
          let sumless10 = parseInt(this.info.mless10)+parseInt(this.info.fless10) | 0

          let sumover70 = parseInt(this.info.mover70) + parseInt(this.info.fover70) | 0
          // totalに加算
          total = sumless10+sumover70+total | 0
          return {
            "sumless10":sumless10,
            "perless10":Math.round(((sumless10)/parseInt(total))*100) | 0,
            "sum10s":pop_array["sum10s"] | 0,
            "per10s":Math.round(((pop_array["sum10s"])/parseInt(total))*100) | 0,
            "sum20s":pop_array["sum20s"] | 0,
            "per20s":Math.round(((pop_array["sum20s"])/parseInt(total))*100) | 0,
            "sum30s":pop_array["sum30s"] | 0,
            "per30s":Math.round(((pop_array["sum30s"])/parseInt(total))*100) | 0,
            "sum40s":pop_array["sum40s"] | 0,
            "per40s":Math.round(((pop_array["sum40s"])/parseInt(total))*100) | 0,
            "sum50s":pop_array["sum50s"] | 0,
            "per50s":Math.round(((pop_array["sum50s"])/parseInt(total))*100) | 0,
            "sum60s":pop_array["sum60s"] | 0,
            "per60s":Math.round(((pop_array["sum60s"])/parseInt(total))*100) | 0,
            "sumover70":sumover70 | 0,
            "perover70":Math.round(((sumover70)/parseInt(total))*100) | 0,
            "total":total | 0
          }
        } else {
          console.log("infoがないからcalcinfo走らないよ")
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.column {
  height: 10px;
}


.popup{
  position: relative;
  display: flex;
  margin: 0 auto;
  height: auto;
  width: 100%;
  justify-content: space-between;
}

.left-block {
  width: 44%;
  margin: 0px;
}

.right-block {
  width: 50%;
  margin: 0px;
}

table {
	border-collapse: collapse;
}
td {
	// border: solid 1px;
  text-align: right;
	padding-right: 1.0em;
  padding-left: 1.0em;
  padding-top: 0.7em;
  padding-bottom: 0.7em;
}

.column {
  text-align: left;
  font-weight: bold;
}

</style>

